module.exports = __webpack_public_path__ + "img/0Q3B3739_L_Wood_MockedUp.8de33466.jpg";